import React from "react";
import { Form, Collapse, Button } from "react-bootstrap";
import { CiFilter } from "react-icons/ci";
import { FaFilter } from "react-icons/fa";
import { useCategories } from "../hooks/useCategory";
import { useAgeGroupProduct } from "../hooks/useAgeGroupProduct";
import { useTypeProduct } from "../hooks/useType";

const FilterCard = ({ open, setOpen, filters, handleFilterChange, submitFilter }) => {
    const { categories } = useCategories();
    const { ageGroupProduct } = useAgeGroupProduct();
    const { typeProduct } = useTypeProduct();

    return (
        <Form
            style={{ backgroundColor: 'transparent', margin: '0rem' }}>
            <Form.Group
                className="d-flex justify-content-between align-items-center"
                onClick={() => setOpen(!open)}
                style={{
                    cursor: "pointer",
                    borderBottom: "2px solid rgb(255, 255, 255)",
                    paddingBottom: "10px",
                    fontSize: 12,
                    backgroundColor: 'transparent',
                    color: 'white'
                }}
            >
                <span>{open ? "Filters" : "Filters"}</span>
                <span>
                    {open ? (
                        <CiFilter size={17} color="white" style={{ marginLeft: "auto" }} />
                    ) : (
                        <FaFilter size={17} color="white" style={{ marginLeft: "auto" }} />
                    )}
                </span>
            </Form.Group>

            <Collapse in={open} style={{ backgroundColor: 'transparent' }}>
                <div id="filter-collapse">
                    {/* Category Filter */}
                    <Form.Group
                        controlId="filterCategory"
                        className="mb-3 mt-2"
                    >
                        {/* <Form.Label style={{ fontSize: 12 }}>Category</Form.Label> */}
                        <Form.Control
                            as="select"
                            name="category"
                            value={filters.category}
                            onChange={handleFilterChange}
                            style={{
                                fontSize: 12,
                                background: 'none',
                                color: 'white',
                                border: 'none',
                                borderBottom: '2px solid white', // Underline effect
                                padding: '5px 10px',
                                appearance: 'none', // Hide default select arrow
                                WebkitAppearance: 'none',
                                MozAppearance: 'none',
                                backgroundImage: "url('data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='white'><path fill-rule='evenodd' d='M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z' clip-rule='evenodd'/></svg>')",
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: 'right 10px center',
                                backgroundSize: '15px',
                                cursor: 'pointer',
                                outline: 'none', // ✅ Prevents focus border
                                boxShadow: 'none', // ✅ Prevents focus glow
                            }}
                            onFocus={(e) => e.target.style.boxShadow = 'none'} // ✅ Extra safety to prevent focus glow
                            onBlur={(e) => e.target.style.boxShadow = 'none'}
                        >
                            <option key='' value='' style={{ background: '#8d070e', color: '#fff' }}>Select category . . .</option>
                            {categories.map((category) => (
                                <option
                                    key={category.id}
                                    value={category.name}
                                    style={{ background: '#8d070e', color: 'white' }} // Dark background & white text
                                >
                                    {category.name}
                                </option>
                            ))}
                        </Form.Control>
                    </Form.Group>

                    {/* Type Filter */}
                    <Form.Group controlId="filterCategory" className="mb-3">
                        {/* <Form.Label style={{ fontSize: 12 }}>Type</Form.Label> */}
                        <Form.Control
                            as="select"
                            name="type"
                            value={filters.type}
                            onChange={handleFilterChange}
                            style={{
                                fontSize: 12,
                                background: 'none',
                                color: 'white',
                                border: 'none',
                                borderBottom: '2px solid white', // Underline effect
                                padding: '5px 10px',
                                appearance: 'none', // Hide default select arrow
                                WebkitAppearance: 'none',
                                MozAppearance: 'none',
                                backgroundImage: "url('data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='white'><path fill-rule='evenodd' d='M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z' clip-rule='evenodd'/></svg>')",
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: 'right 10px center',
                                backgroundSize: '15px',
                                cursor: 'pointer',
                                outline: 'none', // ✅ Prevents focus border
                                boxShadow: 'none', // ✅ Prevents focus glow
                            }}
                            onFocus={(e) => e.target.style.boxShadow = 'none'} // ✅ Extra safety to prevent focus glow
                            onBlur={(e) => e.target.style.boxShadow = 'none'}
                        >
                            <option key='' value='' style={{ background: '#8d070e', color: '#fff' }}>Select type . . .</option>
                            {typeProduct.map((type) => (
                                <option
                                    key={type.id}
                                    value={type.name}
                                    style={{ background: '#8d070e', color: 'white' }} // Dark background & white text
                                >
                                    {type.name}
                                </option>
                            ))}
                        </Form.Control>
                    </Form.Group>

                    {/* Usia Filter */}
                    <Form.Group controlId="filterCategory" className="mb-3">
                        <Form.Control
                            as="select"
                            name="age"
                            value={filters.age}
                            onChange={handleFilterChange}
                            style={{
                                fontSize: 12,
                                background: 'none',
                                color: 'white',
                                border: 'none',
                                borderBottom: '2px solid white', // Underline effect
                                padding: '5px 10px',
                                appearance: 'none', // Hide default select arrow
                                WebkitAppearance: 'none',
                                MozAppearance: 'none',
                                backgroundImage: "url('data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='white'><path fill-rule='evenodd' d='M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z' clip-rule='evenodd'/></svg>')",
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: 'right 10px center',
                                backgroundSize: '15px',
                                cursor: 'pointer',
                                outline: 'none', // ✅ Prevents focus border
                                boxShadow: 'none', // ✅ Prevents focus glow
                            }}
                            onFocus={(e) => e.target.style.boxShadow = 'none'} // ✅ Extra safety to prevent focus glow
                            onBlur={(e) => e.target.style.boxShadow = 'none'}
                        >
                            <option key='' value='' style={{ background: '#8d070e', color: '#fff' }}>
                                Select age . . .
                            </option>
                            {ageGroupProduct.map((age) => (
                                <option
                                    key={age.id}
                                    value={age.name}
                                    style={{ background: '#8d070e', color: 'white' }} // Dark background & white text
                                >
                                    {age.name}
                                </option>
                            ))}
                        </Form.Control>

                    </Form.Group>

                    {/* Jenis Kelamin Filter */}
                    <Form.Group controlId="filterCategory" className="mb-3">
                        {/* <Form.Label style={{ fontSize: 12 }}>Gender</Form.Label> */}
                        <Form.Control
                            as="select"
                            name="sex"
                            value={filters.sex}
                            onChange={handleFilterChange}
                            style={{
                                fontSize: 12,
                                background: 'none',
                                color: 'white',
                                border: 'none',
                                borderBottom: '2px solid white', // Underline effect
                                padding: '5px 10px',
                                appearance: 'none', // Hide default select arrow
                                WebkitAppearance: 'none',
                                MozAppearance: 'none',
                                backgroundImage: "url('data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='white'><path fill-rule='evenodd' d='M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z' clip-rule='evenodd'/></svg>')",
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: 'right 10px center',
                                backgroundSize: '15px',
                                cursor: 'pointer',
                                outline: 'none', // ✅ Prevents focus border
                                boxShadow: 'none', // ✅ Prevents focus glow
                            }}
                            onFocus={(e) => e.target.style.boxShadow = 'none'} // ✅ Extra safety to prevent focus glow
                            onBlur={(e) => e.target.style.boxShadow = 'none'}
                        >
                            <option key='' value='' style={{ background: '#8d070e', color: '#fff' }}>Select gender . . .</option>
                            <option style={{ background: '#8d070e', color: 'white' }} value={1}>Laki - laki</option>
                            <option style={{ background: '#8d070e', color: 'white' }} value={2}>Perempuan</option>
                        </Form.Control>
                    </Form.Group>

                    {/* Price Filter */}
                    <Form.Group controlId="filterPrice" className="mb-3">
                        {/* <Form.Label style={{ fontSize: 12 }}>Price Range</Form.Label> */}
                        <Form.Control
                            type="number"
                            placeholder="e.g., Rp.10 - Rp.10000000"
                            name="price"
                            value={filters.price}
                            onChange={handleFilterChange}
                            style={{
                                fontSize: 12,
                                background: 'none',
                                color: 'white',
                                border: 'none',
                                borderBottom: '2px solid white', // Underline effect
                                padding: '5px 10px',
                                appearance: 'none', // Hide default select arrow
                                WebkitAppearance: 'none',
                                MozAppearance: 'none',
                                backgroundImage: "url('data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='white'><path fill-rule='evenodd' d='M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z' clip-rule='evenodd'/></svg>')",
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: 'right 10px center',
                                backgroundSize: '15px',
                                cursor: 'pointer',
                                outline: 'none', // ✅ Prevents focus border
                                boxShadow: 'none', // ✅ Prevents focus glow
                            }}
                            onFocus={(e) => e.target.style.boxShadow = 'none'} // ✅ Extra safety to prevent focus glow
                            onBlur={(e) => e.target.style.boxShadow = 'none'}
                        />
                    </Form.Group>

                    <Form.Group controlId="filter" className="mt-2">
                        <Button
                            variant="outline-light"
                            onClick={submitFilter}
                            style={{
                                width: '100%',
                                fontSize: 12,
                                color: 'white'
                            }}
                        >
                            Filter
                        </Button>
                    </Form.Group>
                </div>
            </Collapse>
        </Form>
    );
};

export default FilterCard;
